import axios from "axios"
import { Service } from "../services/Service"

const serverBaseURL = process.env.REACT_APP_API_BASE_URL
class LogsApi {
    public static async getLogs(format: string): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(
            `${serverBaseURL}/logs?format=${
                format === "html" ? format : "raw"
            }`,
            {
                headers,
            }
        )
        return response.data
    }
}

export default LogsApi
